//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import StepperNavItem from './StepperNavItem';
import ProgressBar from '~/components/Pages/Register/ProgressBar.vue';

export default {
    components: {
        ProgressBar,
        StepperNavItem,
    },
    provide() {
        return {
            currentStepIndex: this.currentRegistrationStep,
        };
    },
    computed: {
        currentRegistrationStep() {
            let res;

            switch (this.getRouteBaseName()) {
                case 'register':
                    res = 0;
                    break;
                case 'register-company':
                    res = 1;
                    break;
                case 'register-personal-information':
                    res = 2;
                    break;
                case 'register-team':
                    res = 3;
                    break;
            }

            return res;
        },
        nextRegistrationStep() {
            // todo
            return null;
        },
    },
    methods: {},
};
